<template>
  <div class="person-info" :class="{'over-flow-hidden': overflowHidden}">
    <ucar-title>{{title}}</ucar-title>
    <ucar-section class="info-city" :disabled="mode === 'modify'">
      <div class="row">
        <label>服务城市</label>
        <ucar-city-select
          :options="[]"
          :disabled="true"
          @click.native="goIndex('chooseCity')"
          placeholder="请选择"
          v-model="vuexCurrentCity"
        ></ucar-city-select>
      </div>
    </ucar-section>
    <div class="photo-info">
      <div class="photo-group-title">身份证</div>
      <div class="photo-group">
        <ucar-upload-img
          v-bind="photoBaseData.idCard"
          v-model="photoInfo.idCard"
          @uploadFinish="autoInputIdCard"
          :mode="mode"
          :error="vuexDisapproveInfo.errors[photoBaseData.idCard.type]"
          :needModify="vuexDisapproveInfo.needModify.indexOf(photoBaseData.idCard.type) !== -1"
        ></ucar-upload-img>
        <ucar-upload-img
          v-bind="photoBaseData.idCardBack"
          v-model="photoInfo.idCardBack"
          @uploadFinish="autoInputIdCardBack"
          :mode="mode"
          :error="vuexDisapproveInfo.errors[photoBaseData.idCardBack.type]"
          :needModify="vuexDisapproveInfo.needModify.indexOf(photoBaseData.idCardBack.type) !== -1"
        ></ucar-upload-img>
        <ucar-upload-img
          v-bind="photoBaseData.handholdIdCard"
          v-model="photoInfo.handholdIdCard"
          :mode="mode"
          :error="vuexDisapproveInfo.errors[photoBaseData.handholdIdCard.type]"
          :needModify="vuexDisapproveInfo.needModify.indexOf(photoBaseData.handholdIdCard.type) !== -1"
        ></ucar-upload-img>
      </div>
      <div class="photo-group-title">驾驶证</div>
      <div class="photo-group">
        <ucar-upload-img
          v-bind="photoBaseData.license"
          v-model="photoInfo.license"
          @uploadFinish="autoInputLicense"
          :mode="mode"
          :error="vuexDisapproveInfo.errors[photoBaseData.license.type]"
          :needModify="vuexDisapproveInfo.needModify.indexOf(photoBaseData.license.type) !== -1"
        ></ucar-upload-img>
        <ucar-upload-img
          v-bind="photoBaseData.secondLicense"
          v-model="photoInfo.secondLicense"
          :mode="mode"
          :error="vuexDisapproveInfo.errors[photoBaseData.secondLicense.type]"
          :needModify="vuexDisapproveInfo.needModify.indexOf(photoBaseData.secondLicense.type) !== -1"
        ></ucar-upload-img>
      </div>
      <div class="photo-group-title">网络预约出租汽车驾驶员证{{needNetworkLicense ? '' : '（选填）'}}</div>
      <div class="photo-group">
        <ucar-upload-img
          v-bind="photoBaseData.networkLicense"
          :showTitle="false"
          v-model="photoInfo.networkLicense"
          :mode="mode"
          :error="vuexDisapproveInfo.errors[photoBaseData.networkLicense.type]"
          :deletable="!needNetworkLicense"
          :needModify="vuexDisapproveInfo.needModify.indexOf(photoBaseData.networkLicense.type) !== -1"
        ></ucar-upload-img>
      </div>
    </div>
    <ucar-section title="以下为自动识别图片的结果，如不正确请修改" :disabled="mode === 'modify'">
      <div class="row">
        <label>真实姓名</label>
        <input placeholder="请输入" v-model="info.driverName" maxlength="15">
      </div>
      <div class="row">
        <label>身份证号</label>
        <input placeholder="请输入" v-model="info.driverIdCard" maxlength="18">
      </div>
      <div class="row">
        <label>身份证有效期至</label>
        <ucar-date-select
          v-model="info.idCardValidDate"
          :start-date="new Date()"
          :end-date="new Date((new Date()).getFullYear() + 20, (new Date()).getMonth(), (new Date()).getDate())"
        ></ucar-date-select>
      </div>
      <div class="row">
        <label>户籍城市</label>
        <ucar-city-select
          :options="baseData.houseHoldCityList"
          placeholder="请选择"
          @overflow-hidden="reLayout"
          v-model="info.houseHoldCity"
        ></ucar-city-select>
      </div>
      <div class="row">
        <label>性别</label>
        <ucar-select
          :options="baseData.genderOptions"
          placeholder="请选择"
          v-model="info.gender"
        ></ucar-select>
      </div>
      <div class="row">
        <label>驾照初次领取日期</label>
        <ucar-date-select
          v-model="info.firstDrivingLicenseReceiveTime"
          :start-date="new Date(1970, (new Date()).getMonth(), (new Date()).getDate())"
          :end-date="new Date((new Date()).getFullYear() - 3, (new Date()).getMonth(), (new Date()).getDate())"
          tips="请确保驾照领取时间超过3年"
        ></ucar-date-select>
      </div>
      <div class="row">
        <label>驾驶证有效期至</label>
        <ucar-date-select
          v-model="info.driverLicenseValidDate"
          :start-date="new Date()"
          :end-date="new Date((new Date()).getFullYear() + 20, (new Date()).getMonth(), (new Date()).getDate())"
        ></ucar-date-select>
      </div>
      <div class="row">
        <label>招募来源（选填）</label>
        <ucar-select
          :options="baseData.channelOptions"
          placeholder="请选择"
          v-model="info.recruitSourceId"
        ></ucar-select>
      </div>
    </ucar-section>
    <div class="footer">
      <button type="button" class="btn-submit" :class="{'btn-submit-enable': enableSubmit}" @click="submit">
        {{vuexRegType === '2' || vuexDisapproveInfo.errorType === 1 ? '提交' : '下一步'}}
      </button>
    </div>
  </div>
</template>

<script>
import valid from '../../utils/valid-check'
import preload from '../../utils/preload'
import { PhotoBaseData } from '../../utils/constants'
import { transformCities, transformImgUrl, transformReferrer } from '../../utils/transform'
import { getRecruitSources, getHouseHoldCities, validPersonInfo, spotIdCard, spotDriverLicense } from '../../api'
export default {
  name: 'person-info',
  data () {
    return {
      mode: 'normal',
      info: {
        driverName: '',
        driverIdCard: '',
        idCardValidDate: '',
        houseHoldCity: {},
        gender: '1',
        firstDrivingLicenseReceiveTime: '',
        driverLicenseValidDate: '',
        recruitSourceId: ''
      },
      photoInfo: {
        idCard: '',
        idCardBack: '',
        handholdIdCard: '',
        license: '',
        secondLicense: '',
        networkLicense: ''
      },
      photoBaseData: PhotoBaseData,
      baseData: {
        genderOptions: [
          {
            name: '男',
            value: '1'
          },
          {
            name: '女',
            value: '0'
          }
        ],
        houseHoldCityList: [],
        tempHouseHoldCityList: [],
        serviceCityList: [],
        channelOptions: []
      },
      overflowHidden: false
    }
  },
  computed: {
    needNetworkLicense() {
      return this.vuexCompanyId ? this.vuexCurrentCity.needCompanyNetworkLicense : this.vuexCurrentCity.needNetworkLicense
    },
    enableSubmit () {
      const errorInfo = valid.notEmpty(this.photoInfo.idCard, '身份证正面') ||
        valid.notEmpty(this.photoInfo.idCardBack, '身份证国徽面') ||
        valid.notEmpty(this.photoInfo.handholdIdCard, '手持本人身份证') ||
        valid.notEmpty(this.photoInfo.license, '驾驶证正本') ||
        valid.notEmpty(this.photoInfo.secondLicense, '驾驶证副本') ||
        (this.needNetworkLicense &&
        valid.notEmpty(this.photoInfo.networkLicense, '网络预约出租汽车驾驶员证')) ||
        valid.notEmpty(this.info.driverName, '真实姓名') ||
        valid.notEmpty(this.info.driverIdCard, '身份证号') ||
        valid.notEmpty(this.info.idCardValidDate, '身份证有效日期') ||
        valid.notEmpty(this.info.driverLicenseValidDate, '驾驶证有效日期') ||
        valid.notEmpty(this.info.houseHoldCity, '户籍城市') ||
        valid.notEmpty(
          this.info.firstDrivingLicenseReceiveTime,
          '驾照初次领取日期'
        )
      return errorInfo === ''
    }
  },
  watch: {
    'info.driverName' (val) {
      this.info.driverName = val.replace(/\s/g, '').substr(0, 15)
    },
    'info.driverIdCard' (val) {
      this.info.driverIdCard = val.replace(/[^\dxX]/g, '').toUpperCase().substr(0, 18)
    }
  },
  methods: {
    reLayout (val) {
      this.overflowHidden = val
      if (!this.overflowHidden) {
        setTimeout(() => {
          document.documentElement.scroll(0, 2000)
          document.body.scroll(0, 2000)
        })
      }
    },
    cacheData () {
      const data = { baseInfo: this.info, photoInfo: this.photoInfo }
      this.setVuexPersonInfo(data)
      this.cacheInfoForLongTime('person', data)
    },
    getBaseData () {
      this.$loading.show()
      preload([
        PhotoBaseData.idCard.defaultImg,
        PhotoBaseData.idCardBack.defaultImg,
        PhotoBaseData.handholdIdCard.defaultImg,
        PhotoBaseData.license.defaultImg,
        PhotoBaseData.secondLicense.defaultImg,
        PhotoBaseData.networkLicense.defaultImg
      ]).then(() => {
        return Promise.all([
          getRecruitSources(),
          getHouseHoldCities()
        ])
      }).then(res => {
        this.baseData.channelOptions = res[0].recruitSourceList.map(item => {
          return {
            name: item.recruitSource,
            value: item.recruitSourceId
          }
        })
        this.baseData.tempHouseHoldCityList = res[1].houseHoldCityList
        this.baseData.houseHoldCityList = transformCities(
          res[1].houseHoldCityList
        , false)
        const cachedInfo = this.findCachedInfo()
        if (cachedInfo && cachedInfo.personInfo) {
          this.setVuexPersonInfo(cachedInfo.personInfo)
        }
        if (
          this.mode !== 'modify' &&
          this.vuexPersonInfo !== null &&
          typeof this.vuexPersonInfo === 'object' &&
          Object.keys(this.vuexPersonInfo).length > 0
        ) {
          this.info = this.vuexPersonInfo.baseInfo
          this.photoInfo = this.vuexPersonInfo.photoInfo
        }
        this.modifyInit()
        this.$loading.hidden()
      })
    },
    goIndex () {
      this.cacheData()
      this.$alert({
        type: 'confirm',
        dsc: '不同服务城市的业务不同，更改服务城市后需重新选择加入方式',
        okText: '确认更改',
        showCancel: true,
        center: true,
        callback: () => {
          this.$router.push(this.vuexCompanyId ? `${this.vuexIndexUrl}&showCityChoose=true` : '/?showCityChoose=true')
        }
      })
    },
    autoInputIdCard (val) {
      spotIdCard({
        faceImagePath: val
      }).then(res => {
        if (res.idCardNo) this.info.driverIdCard = res.idCardNo
        if (res.name) this.info.driverName = res.name
        if (res.gender) this.info.gender = res.gender === '男' ? '1' : '0'
        if (res.domicileCity) {
          const houseHoldCity = this.baseData.tempHouseHoldCityList.find(item => {
            return item.cityName === res.domicileCity
          })
          this.info.houseHoldCity = houseHoldCity ? { ...houseHoldCity, name: houseHoldCity.cityName, id: houseHoldCity.cityId } : {}
        }
      })
    },
    autoInputIdCardBack (val) {
      spotIdCard({
        backImagePath: val
      }).then(res => {
        if (valid.date(res.expiryDateTo)) this.info.idCardValidDate = res.expiryDateTo
      })
    },
    autoInputLicense (val) {
      spotDriverLicense({
        imagePath: val
      }).then(res => {
        if (valid.date(res.issueDate)) this.info.firstDrivingLicenseReceiveTime = res.issueDate
        if (valid.date(res.expiryDateTo)) this.info.driverLicenseValidDate = res.expiryDateTo
      })
    },
    submit () {
      const errorInfo =
        valid.cnName(this.info.driverName) ||
        valid.nameLimit(this.info.driverName) ||
        valid.idCard(this.info.driverIdCard)
      if (errorInfo) {
        this.$alert(errorInfo)
        return
      }
      if (this.mode === 'modify') {
        this.submitModify()
        return
      }
      const personInfo = {
        recruitType: Number(this.vuexRegType),
        driverName: this.info.driverName,
        gender: Number(this.info.gender),
        driverIdCard: this.info.driverIdCard,
        mobile: this.vuexPersonMobile,
        houseHoldCity: this.info.houseHoldCity.name,
        serviceCityId: Number(this.vuexCurrentCity.id),
        recruitSourceId: this.info.recruitSourceId,
        firstDrivingLicenseReceiveTime: this.info.firstDrivingLicenseReceiveTime,
        companyId: this.vuexCompanyId ? this.vuexCompanyId : '',
        idCardImgUrl: this.photoInfo.idCard,
        idCardBackPath: this.photoInfo.idCardBack,
        idCardImgHoldUrl: this.photoInfo.handholdIdCard,
        licenseImgUrl: this.photoInfo.license,
        licenseCopyImgUrl: this.photoInfo.secondLicense,
        onLineDrivingLicenseUrl: this.photoInfo.networkLicense,
        licenseExpiryDate: this.info.driverLicenseValidDate,
        idCardExpiryDate: this.info.idCardValidDate,
        from: this.vuexFrom,
        fromRemark: transformReferrer(),
        ...this.vuexRecruitStatus
      }
      if (this.info.recruitSourceId) {
        personInfo.recruitSourceId = Number(this.info.recruitSourceId)
      }
      // 由于接口方暂时不支持https协议的图片地址，所以将所有待上传的图片链接地址转换为http协议
      const submitInfo = transformImgUrl({ ...this.vuexSubmitInfo, ...personInfo })
      validPersonInfo(submitInfo).then(res => {
        if (res.failureCode === 41) return this.handleStatusChange(res)
        if (res.isBaseInfoEnable) {
          this.setVuexSubmitInfo(submitInfo)
          this.cacheData()
          if (this.vuexRegType !== '2' && this.vuexRegType !== '4') {
            this.$router.push('/car-info')
          } else {
            this.trackEvent('XQ_tjzlpage_tj_click')
            this.finalSubmit()
              .then(res => this.handleStatusChange(res))
          }
        } else {
          this.$alert({
            type: 'confirm',
            dsc: res.failMess || '系统繁忙',
            center: true
          })
        }
      })
    }
  },
  mounted () {
    if ((this.vuexRegType === '2' && (!this.vuexCurrentCity.noCar && !this.vuexCurrentCity.rentCar && !this.vuexCurrentCity.buyCar)) ||
    (this.vuexRegType === '3' && !this.vuexCurrentCity.hasCar)) {
      this.$alert({
        type: 'confirm',
        dsc: `当前服务城市暂未开通${this.vuexRegType === '2' ? '无车加入' : '带车加入'}`,
        okText: '重新选择服务城市',
        center: true,
        callback: () => {
          this.$router.push('/?showCityChoose=true')
        }
      })
      return
    }
    this.getBaseData()
  }
}
</script>
